// NOTE: NSAI-6319 — the two values behind the SSO auto-redirect loop guard.
// They live next to the auth pages rather than in the global constants file
// because nothing outside this flow reads them.

// NOTE: sessionStorage, not localStorage: the guard is about one tab's
// navigation loop and has no business outliving the tab.
export const SSO_AUTO_REDIRECT_STORAGE_KEY = "sso_auto_redirect_attempted_at";

// NOTE: A cooldown rather than a one-shot flag, because the two things being
// told apart differ by orders of magnitude in time. The loop this guard exists
// for — IdP → /api/auth/saml-callback → /auth/sso → IdP — completes a lap in
// well under a second, while a person who comes back to sign in again is
// minutes away. A hard one-shot flag would have sent that person to the email
// form on a deployment whose entire login flow IS the auto-redirect.
export const SSO_AUTO_REDIRECT_COOLDOWN_MS = 15_000;
